var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSimpleIllustrationStopwatch = function SvgSimpleIllustrationStopwatch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "simple-illustration__stopwatch_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 68 68",
    style: {
      enableBackground: "new 0 0 68 68"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".simple-illustration__stopwatch_svg__st2{fill:#003c73}.simple-illustration__stopwatch_svg__st3{fill:#f25730}.simple-illustration__stopwatch_svg__st4{fill:none;stroke:#002140;stroke-width:1;stroke-linecap:round;stroke-linejoin:round}")), /*#__PURE__*/React.createElement("path", {
    d: "M34.266 59.294c12.67 0 22.942-10.271 22.942-22.942 0-12.67-10.271-22.942-22.942-22.942-12.67 0-22.942 10.271-22.942 22.942.001 12.671 10.272 22.942 22.942 22.942z",
    style: {
      fill: "#ffed8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.191 53.194c9.471 0 17.148-7.678 17.148-17.149s-7.678-17.148-17.148-17.148c-9.471 0-17.149 7.678-17.149 17.148 0 9.472 7.678 17.149 17.149 17.149z",
    style: {
      fill: "#fffaf0"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__stopwatch_svg__st2",
    d: "m22.449 16.136-4.259-4.028s-5.864 1.609-6.096 6.216l3.339 3.566s4.486-5.18 7.02-5.753h-.004zM46.271 16.478s5.984 5.18 6.558 6.1l3.566-3.913s-.116-2.877-1.956-4.259c-1.841-1.383-4.486-1.841-4.486-1.841l-3.682 3.913z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__stopwatch_svg__st3",
    d: "M30.389 13.144s5.295-.574 7.251.116v-2.072l-.572-1.668s-1.485-.405-3.223-.405c-3.339 0-3.415 1.249-3.455 1.383-.04.134-.001 2.646-.001 2.646z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__stopwatch_svg__st4",
    d: "M34.075 59.005c12.744 0 23.075-10.331 23.075-23.075S46.819 12.855 34.075 12.855 11 23.186 11 35.93s10.331 23.075 23.075 23.075z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__stopwatch_svg__st4",
    d: "M34.075 53.319c9.603 0 17.389-7.785 17.389-17.389 0-9.603-7.785-17.389-17.389-17.389-9.603 0-17.389 7.785-17.389 17.389s7.785 17.389 17.389 17.389z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__stopwatch_svg__st3",
    d: "M34.075 39.114a3.183 3.183 0 1 0 0-6.366 3.183 3.183 0 0 0 0 6.366z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__stopwatch_svg__st4",
    d: "m40.122 41.781 3.828 3.828M15.544 21.658l-3.143-2.957a1.46 1.46 0 0 1-.28-1.77 10.53 10.53 0 0 1 5.189-4.619c.52-.218 1.125-.089 1.538.298l3.255 3.063M14.681 14.353l4.162 3.89M16.371 13.086l4.162 3.895M12.917 16.038l4.166 3.895M52.949 21.965l3.143-2.957a1.46 1.46 0 0 0 .28-1.77 10.53 10.53 0 0 0-5.189-4.619c-.52-.218-1.125-.089-1.538.298L46.39 15.98M53.811 14.66l-4.161 3.89M52.126 13.393l-4.166 3.895M55.577 16.345l-4.162 3.895M30.354 12.988v-2.361c0-.898.729-1.627 1.627-1.627h4.108c.898 0 1.627.729 1.627 1.627v2.263"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__stopwatch_svg__st3",
    d: "M35.493 25.344h-2.917v10.279h2.917V25.344z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__stopwatch_svg__st3",
    d: "m35.472 34.597-2.062 2.062L43.8 47.05l2.062-2.062-10.39-10.391z"
  })));
};
export default SvgSimpleIllustrationStopwatch;